import { graphql, gqlRequest } from '@client/shared/graphql';

const DismissMyTutorialMutation = graphql(`
  mutation DismissMyTutorial {
    dismissMyTutorial {
      id
      tutorialDismissedAt
    }
  }
`);

export async function dismissMyTutorial(): Promise<void> {
  await gqlRequest(DismissMyTutorialMutation, {});
}
